/* globals angular */
(function () {
  'use strict';

  var updateTerms = {
    template: require('./terms.html'),
    controller: 'UpdateTermsCtrl',
  };

  angular
    .module('mandaeApp')
    .component('updateTerms', updateTerms)
    .config(['$stateProvider', function ($stateProvider) {
      $stateProvider
        .state('atualizar-termos-de-uso', {
          parent: 'finalizar-cadastro',
          component: 'updateTerms',
          url: '/atualizar-termos-de-uso',
          params: {
            user: null,
          },
        });
    }]);

}());
